export enum RoutesEnum {
    login = "login",
    successSignup = "success-signup",
    signup = "signup",
    monespace = "monespace",
    resetpassword = "resetpassword",
}
